export enum State {
  INIT = 'init',

  ABORT_STANDARD_APPLICATION_PROMPT = 'abort-standard-application-prompt',
  ABORT_APPLICATION = 'abort-application',

  ONBOARDING_RESEARCH = 'onboarding-research',

  ABORT = 'abort',
  ABORT_TO_CAPITAL_DEPOSIT = 'abort-to-capital-deposit',

  PRICING_PLAN = 'pricing-plan',
  BUSINESS_INFO = 'business-info',
  PERSONAL_INFO = 'personal-info',
  COMPANY_COMPLIANCE = 'company-compliance',

  USER_PROFILE_SEND = 'user-profile-send',

  VERIFICATION = 'verification',
  AGREEMENT = 'agreement',
  SEND_APPLICATION = 'send-application',
  REVIEW = 'review',

  BENEFICIARIES_DOCS = 'beneficiaries-docs',
  BENEFICIARIES_DOCS_INTRO = 'beneficiaries-docs-intro',

  CANNOT_OPEN_ACCOUNT = 'cannot-open-account',
  DOWNLOAD_SHINE_MESSAGE_SENT = 'download-shine-message-sent',

  CHECK_IDENTITY_DOCUMENT = 'check-identity-document',

  DONE = 'done',
}
